var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('v-container',{staticClass:"ma-0 pa-0"},[(_vm.$vuetify.breakpoint.smAndUp)?_c('MainTitle',{attrs:{"mainTitleName":_vm.mainTitleName}}):_vm._e(),_c('MainMessageList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }